module.exports = __webpack_public_path__ + "img/open-and-click-svg.7f3a67a6.svg";